module.exports = __webpack_public_path__ + "static/media/monaco-flag.d0776bf9.png";